/**
 * Experiment to enable exclusivity agreements for retailers
 * Product Area: EXCLUSIVITY
 */
export const ENABLE_EXCLUSIVITY_AGREEMENTS_FOR_RETAILERS_230915 = 'ENABLE_EXCLUSIVITY_AGREEMENTS_FOR_RETAILERS_230915';
